import { render, staticRenderFns } from "./TheOrganizationBusinessRoleForm.vue?vue&type=template&id=4f18d916&"
import script from "./TheOrganizationBusinessRoleForm.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationBusinessRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports